import { Controller } from 'stimulus';

export default class extends Controller {
  disconnect() {
    if (document.querySelector('[data-dom-cleanup="true"]')) {
      document.addEventListener('turbolinks:before-cache', this.domCleanup());
    }
  }

  toggle(event) {
    event.preventDefault()
    const elements = this._getElements()
    this._toggle(elements)
  }

  hide(event) {
    event.preventDefault()
    const elements = this._getElements()
    this._hide(elements)
  }

  show(event) {
    event.preventDefault()
    const elements = this._getElements()
    this._show(elements)
  }

  hideAll(event) {
    event.preventDefault()
    const allElements = document.querySelectorAll('[data-toggle-id]')
    this._hide(allElements)
  }
  
  hideSelf(event) {
    event.preventDefault()
    event.target.classList.add('hide')
  }

  domCleanup() {
    const allElements = document.querySelectorAll('[data-toggle-id]')
    this._hide(allElements)
  }

  // Private

    _getElements() {
      const toggleId = this._getToggleId()
      return document.querySelectorAll(`[data-toggle-id="${toggleId}"]`)
    }

    _getToggleId () {
      if (this.element.dataset.elementToggleId) {
        return this.element.dataset.elementToggleId
      } else {
        return this.element.value
      }
    }

    _toggle(elements) {
      for (const element of elements) {
        if (element != this.element) {
          element.classList.toggle('hide')
        }
      }
    }

    _show(elements) {
      for (const element of elements) {
        element == this.element ? false : element.classList.remove('hide')
      }
    }

    _hide(elements) {
      for (const element of elements) {
        element == this.element ? false : element.classList.add('hide')
      }
    }
}